<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/IMG_0038.JPG">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <!-- <span class="headline">Welcome to the Coletti-Spaghetti Birthday Quiz</span> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Welcome to the Coletti-Spaghetti Birthday Quiz</span>
            <br>
            <!-- <span>Are you ready?</span><br> -->
            <span>Are you ready?</span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn to="/question1" flat color="orange">Begin</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
export default {
    created() {
     this.$store.dispatch('resetScore');
   },
};
</script>
